export const errorMessage = async (error) => {
  let errorMsg = "";

  if (error.message) {
    errorMsg = error.message.replace("GraphQL error: ", "");
  } else if (error.graphQLErrors) {
    errorMsg =
      error.graphQLErrors.length > 0
        ? error.graphQLErrors[0].message
        : error.networkError.message;
  } else if (error.networkError) {
    errorMsg = error.networkError.message;
  }

  return errorMsg;
};

export const setError = async (module, error) => {
  module.setError(await errorMessage(error));

  setTimeout(() => {
    module.setError(null);
  }, 3000);
};
